const AttributesList = ({ data = [], setProduct }) => {
    const handleDelete = (index) => {
        setProduct(prev => {
            prev.attributes.splice(index, 1);
            return { ...prev }
        })
    }
    return (
        <>
            <ul className='divide-y divide-gray-300'>
                {data.map((i, index) => {
                    return (
                        <li key={i.name} className='flex items-center gap-2 p-2'>
                            <span className='cursor-pointer border border-red-500 rounded-full centerOfParent' onClick={() => handleDelete(index)}>
                                <svg fill='red' stroke="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path></svg>
                            </span>
                            <div className="flex flex-col divide-y w-full">
                                <p className='w-full text-right pb-1'>{i.name} :</p>
                                <p className='w-full text-right pt-1'>{i.value}</p>
                            </div>
                        </li>
                    )
                })}
            </ul>
        </>
    );
};

export default AttributesList;